import { CompanyBlockedUserData } from '@tymbe/schema/company-blocked-user.interface';
import moment from 'moment';

import { BlockReasonDisplay } from '../../../../utils/enums';

interface CompanyBlocksTooltipProps {
  blockList?: CompanyBlockedUserData[];
}

const CompanyBlocksTooltip = ({ blockList = [] }: CompanyBlocksTooltipProps) => (
  <div className="w-52 max-h-64 overflow-scroll text-left flex flex-col gap-2">
    {blockList.map((block) => (
      <div key={block.company?.id}>
        <div className="text-left text-white text-body-1-xl font-semibold">
          {block.company?.name}
        </div>
        <div className="font-semibold">
          {block.branchoffice?.name}
        </div>
        <div>
          {moment(block.created_at).format('DD.MM.YYYY')}
        </div>
        <div>
          {BlockReasonDisplay[block.reason]}
        </div>
      </div>
    ))}
  </div>
);

export default CompanyBlocksTooltip;
